import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
var nullifyString = function nullifyString(value) {
  return value === '' ? null : value;
};
var builder = {
  and: function and() {
    for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
      queries[_key] = arguments[_key];
    }
    return nullifyString(_filterInstanceProperty(queries).call(queries, function (i) {
      return i;
    }).join(' and '));
  },
  or: function or() {
    for (var _len2 = arguments.length, queries = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      queries[_key2] = arguments[_key2];
    }
    return nullifyString(_filterInstanceProperty(queries).call(queries, function (i) {
      return i;
    }).join(', '));
  },
  minWidth: function minWidth(width) {
    return width && width !== '0px' ? "(min-width: ".concat(width, ")") : null;
  },
  maxWidth: function maxWidth(width) {
    return width ? "(max-width: ".concat(width, ")") : null;
  },
  minResolution: function minResolution(res) {
    return res && res !== '96dpi' ? "(min-resolution: ".concat(res, ")") : null;
  },
  maxResolution: function maxResolution(res) {
    return res ? "(max-resolution: ".concat(res, ")") : null;
  },
  minPixelDensity: function minPixelDensity(density) {
    return density && density !== '1' ? "(-webkit-min-device-pixel-ratio: ".concat(density, ")") : null;
  },
  maxPixelDensity: function maxPixelDensity(density) {
    return density ? "(-webkit-max-device-pixel-ratio: ".concat(density, ")") : null;
  }
};
var createMediaQuery = function createMediaQuery(_ref) {
  var minResolution = _ref.minResolution,
    maxResolution = _ref.maxResolution,
    minPixelDensity = _ref.minPixelDensity,
    maxPixelDensity = _ref.maxPixelDensity,
    minWidth = _ref.minWidth,
    maxWidth = _ref.maxWidth;
  return builder.or(builder.and(builder.minResolution(minResolution), builder.minWidth(minWidth), builder.maxResolution(maxResolution), builder.maxWidth(maxWidth)), builder.and(builder.minPixelDensity(minPixelDensity), builder.minWidth(minWidth), builder.maxPixelDensity(maxPixelDensity), builder.maxWidth(maxWidth)));
};
export default createMediaQuery;